<aw-section
  testIdAffix="appearance-standard-controls"
  [isCollapsible]="true"
  [forceCollapse]="forceCollapse()"
  [withoutContentPadding]="true">
  <aw-section-header>
    <div class="grid w-full grid-cols-1 lg:grid-cols-[1fr_minmax(0,6rem)_7fr]">
      <span
        class="text-standard-text-primary text-2xl font-semibold lg:col-span-4">
        {{ cmsTextProvider.appearanceText.controls }}
      </span>
    </div>
  </aw-section-header>

  <div
    class="grid grid-cols-1 gap-6 pt-7 xl:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <h3 class="text-standard-text-primary ml-8 text-xl font-semibold">
      {{ cmsTextProvider.appearanceText.controlsColours }}
    </h3>

    <div class="min-w-0">
      <p class="text-standard-text-secondary text-m mb-2 leading-5">
        {{ cmsTextProvider.appearanceText.controlsColoursHint }}
      </p>

      <div class="grid grid-cols-1 gap-3 2xl:grid-cols-2">
        <ng-container *ngTemplateOutlet="previewCard; context: { dark: false }" />
        <ng-container *ngTemplateOutlet="previewCard; context: { dark: true }" />
      </div>
    </div>
  </div>
</aw-section>

<ng-template #previewCard let-dark="dark">
  <aw-theme context="shop" [mode]="dark ? 'dark' : 'light'" [design]="design()">
    <article class="rounded-[0.375rem] border">
      <div class="flex justify-end px-3 pt-3">
        <span
          class="inline-flex h-8 items-center justify-center gap-1.5 rounded-full border px-2.5 py-0 text-sm leading-none border-standard-outline">
          <span
            aria-hidden="true"
            class="material-symbols-rounded icon-filled inline-flex size-5 shrink-0 items-center justify-center !text-lg leading-none">
            {{ dark ? 'dark_mode' : 'light_mode' }}
          </span>
          <span class="inline-flex h-5 items-center leading-none">
            {{
              dark
                ? cmsTextProvider.appearanceText.controlsDarkMode
                : cmsTextProvider.appearanceText.controlsLightMode
            }}
          </span>
        </span>
      </div>

      <div class="grid grid-cols-[minmax(0,1fr)_minmax(9rem,1fr)] gap-5 p-3" [formGroup]="form">
        <div class="flex min-w-0 flex-col gap-2">
          <aw-button type="button" [id]="'1'" [style]="'primary'" [buttonSize]="'small'">
            <span class="material-symbols-rounded">add</span>
            {{ cmsTextProvider.appearanceText.controlsAction }}
          </aw-button>

          <aw-button type="button" [id]="'2'" [style]="'primary-alt'" [buttonSize]="'small'">
            <span class="material-symbols-rounded">add</span>
            {{ cmsTextProvider.appearanceText.controlsSecondaryAction }}
          </aw-button>

          <aw-button type="button" [id]="'3'" [style]="'tertiary'" [buttonSize]="'small'">
            <span class="material-symbols-rounded">add</span>
            {{ cmsTextProvider.appearanceText.controlsTertiaryAction }}
          </aw-button>

          <aw-text-input id="textInput1"
            formControlName="text"
            [label]="cmsTextProvider.appearanceText.controlsLabel">
          </aw-text-input>

          <div class="relative flex h-12.5 items-center rounded-lg border-1 px-3 pt-2 input-focus-ring border-input-focus bg-input-background">
            <span class="absolute -top-2 px-0.5 left-3.5 text-sm text-input-focus bg-inherit">
              {{ cmsTextProvider.appearanceText.controlsLabel }}
            </span>
            <span class="flex-1 text-base">
              {{ cmsTextProvider.appearanceText.controlsInput }}
            </span>
          </div>
        </div>

        <div
          class="grid grid-cols-[1fr_auto_auto] items-center gap-x-4 gap-y-5 text-base">
          <span>{{ cmsTextProvider.appearanceText.controlsCheckbox }}</span>
          <aw-checkbox formControlName="checkBox1" id="checkBox1" class="w-max pl-3" />
          <aw-checkbox formControlName="checkBox2" id="checkBox2" class="w-max pl-3"/>

          <span>{{ cmsTextProvider.appearanceText.controlsRadio }}</span>
          <aw-single-select
            formControlName="singleSelect1"
            [id]="'1-single-select1-' + dark"
            [options]="[1]" />
          <aw-single-select
            formControlName="singleSelect2"
            [id]="'2-single-select1-' + dark"
            [options]="[2]" />

          <span>{{ cmsTextProvider.appearanceText.controlsSwitch }}</span>
          <aw-toggle formControlName="toggle1" id="toggle1" />
          <aw-toggle formControlName="toggle2" id="toggle2" />

          <div class="col-span-3">
            <aw-button-group id="buttonGroup" formControlName="buttonControl" [buttonWidth]="204"
              [options]="[{label: cmsTextProvider.appearanceText.controlsLabel, value: 1}, {label: cmsTextProvider.appearanceText.controlsLabel, value: 2}]" />
          </div>
        </div>
      </div>

      <div class="mx-3 border-t border-standard-outline"></div>

      <div class="flex flex-col gap-3 p-3">
        @for (color of colors; track color.key) {
          <div>
            <div class="relative flex items-center gap-2 text-base">
              <aw-color-picker-list 
                [color]="swatchColor(color.key, dark)"
                (colorChanged)="selectColor(color.key, dark, $event)"></aw-color-picker-list>
              <span>{{ color.label }}</span>
            </div>

            @if (color.description) {
              <p
                class="mt-1 pl-8 text-sm leading-5"
                [ngClass]="dark ? 'text-neutral-400' : 'text-neutral-500'">
                {{ color.description }}
              </p>
            }
          </div>
        }
      </div>
    </article>
  </aw-theme>
</ng-template>
